import Quill from 'quill';

export class MentionBlot extends Quill.import('blots/embed') {
  static blotName = 'mention';
  static tagName = 'span';
  static className = 'mention';

  static create(value: string): HTMLElement {
    const node: HTMLElement = super.create();
    node.setAttribute('contenteditable', 'false');
    node.innerText = value;

    return node;
  }
}
